import axios from "axios";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

export const LOGIN_PATH = "/login";
export const FORBIDDEN_MESSAGE =
  "You do not have permission to perform this action.";

const PUBLIC_AUTH_PATHS = [LOGIN_PATH, "/forgot-password", "/reset-password"];

export const isPublicAuthPath = (pathname = "") =>
  PUBLIC_AUTH_PATHS.some(
    (publicPath) =>
      pathname === publicPath || pathname.startsWith(`${publicPath}/`)
  );

export const handleApiResponseError = (
  error,
  {
    cookieStore = Cookies,
    location = typeof window === "undefined" ? null : window.location,
    showForbidden = (message, options) => toast.error(message, options),
  } = {}
) => {
  const status = error?.response?.status;

  if (status === 401) {
    cookieStore.remove("accessToken");

    if (location && !isPublicAuthPath(location.pathname)) {
      location.replace(LOGIN_PATH);
    }
  } else if (status === 403) {
    showForbidden(FORBIDDEN_MESSAGE, { id: "authorization-error" });
  }
};

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 40000,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = Cookies.get("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    handleApiResponseError(error);
    return Promise.reject(error);
  }
);

export default apiClient;

/* 
To integrate SWR for efficient API caching while still using Redux Toolkit for other state management, we’ll modify the GET request for fetching the user profile. SWR handles data caching, revalidation, and error states out of the box, which is useful when frequently fetching the same API data.

Here’s the complete example with SWR for the GET request and Redux Toolkit for the POST request.

Step 1: Folder Structure
Step 2: API Client (Axios Configuration)
Step 3: Service Layer (API Call Logic)
 -- We'll modify the service layer to work well with both Redux and SWR. For the POST request, keep using registerUser, but for the GET request, we’ll use SWR in our component.

Step 4: Redux Toolkit Setup (for POST Request)
Set up Redux Toolkit to manage the POST request, keeping registerUser logic in the slice.

Step 5: SWR for API Caching
Now we integrate SWR for the GET request (fetching user profile).
  Install SWR:
  Create a custom hook to fetch the user profile using SWR.

Step 6: Global Error Handling and Notifications
You can continue to use the handleApiError utility for handling errors globally, including those in SWR.

Step 7: Component Example (Register and Fetch User with SWR)
Now, in your React component, you can combine SWR for fetching the user profile and Redux Toolkit for registering a user.
*/
